import { useContext } from "react";
import { OrderStates } from "@adamlip/okeoke.client";
import { MainContext } from "contexts/MainContext";
import IconComponent from "components/IconComponent";
import useBasket from "hooks/useBasket";

export default function BasketWithBadge({ icon, isGrid }) {
  const { itemCount, orderState } = useBasket();

  const { handleClickCart } = useContext(MainContext);

  return (
    <>
      <div
        className={`flex shrink-0 justify-center items-center p-2 rounded-[var(--general-border-radius)] bg-primary/20 relative ${
          isGrid ? "w-14 h-14" : "w-full max-w-[300px] h-12 mx-auto"
        }`}
        onClick={() => handleClickCart()}
      >
        <div
          className={`absolute top-[-5px] right-[-5px] rounded-full w-6 h-6 flex items-center justify-center text-sm bg-[var(--top-bar-cart-badge-bg-color)] text-[var(--top-bar-cart-badge-text-color)] ${
            itemCount > 0 && orderState === OrderStates.BASKET
              ? "basket-badge-visible"
              : "basket-badge-not-visible"
          }`}
        >
          {itemCount}
        </div>
        <IconComponent iconCode={icon || "basket"} className="primary" />
      </div>
    </>
  );
}
